import FullWidthLayout from "@/layouts/FullWidthLayout";
import WorkOrdersTable from "kinnect-front/FacilityMaintenance/WorkOrders/WorkOrdersTable";
import {
	Broadcastable,
	FetchesData,
	Pageable
} from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import {
	VCard,
	VSheet
} from "vuetify/lib";

export default {
	name: "FacilityMaintenanceWorkOrdersPage",

	metaInfo: { title: "Facility Maintenance - Work Orders" },

	mixins: [
		Broadcastable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		search: "",
		actions: {
			add: {
				icon: "add_circle",
				text: "Add Work Order",
				to: { name: "facilityMaintenanceWorkOrderAdd" },
				tooltip: "Add a new work order"
			},
			completed: {
				icon: "done",
				text: "Completed",
				to: { name: "facilityMaintenanceCompletedWorkOrders" },
				tooltip: "View completed work orders"
			},
			request: {
				icon: "add_circle",
				text: "Request Work Order",
				to: { name: "facilityMaintenanceWorkOrderRequest" },
				tooltip: "Request a new work order"
			},
			requests: {
				badge: null,
				icon: "room_service",
				text: "Requests",
				to: { name: "facilityMaintenanceWorkOrderRequests" },
				tooltip: "View work order requests"
			}
		}
	} ),

	computed: {
		toolbarActions() {
			if ( this.$can( "add_facility_maintenance_work_orders" ) ) {
				return [
					this.actions.add,
					this.actions.completed,
					this.actions.requests
				];
			}

			return this.actions.request;
		},

		broadcasts() {
			const broadcasts = [];

			if ( this.$can( "add_facility_maintenance_work_orders" ) ) {
				broadcasts.push( {
					channel: "work-order",
					propKey: "badge",
					propPath: "actions.requests",
					eventNames: {
						r: "work-order.requested.count"
					}
				} );
			}

			return broadcasts;
		}
	},

	methods: {
		async fetchNumRequests() {
			if ( this.$can( "add_facility_maintenance_work_orders" ) ) {
				this.actions.requests.badge = await this.$http
				.get( "facility-maintenance/work-orders/count?filter[approved]=false" )
				.then( resp => resp.data );
			}
		},

		async fetch() {
			await this.fetchNumRequests();
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<WorkOrdersTable
					itemsFilter={item => item.approved && !item.completed}
					modifyItemsQuery={query => query.where( "approved", true ).where( "completed", false )}
					search={this.search}
				></WorkOrdersTable>
			</VCard>
		</FullWidthLayout>;
	}
};
